<template>
  <div v-if="masquerading.status" class="p-3 bg-black text-white text-center border-t-8 border-red">
    <div class="flex justify-center">
      <div class="pr-1">
        Return to {{ masquerading.name }}'s account
      </div>
      <button class="text-white hover:text-red" @click="stopMasquerading"><LogoutIcon /></button>
    </div>
  </div>
</template>

<script>
import LogoutIcon from "../../icons/LogoutIcon.vue";

export default {
  name: "MasqueradingBanner",
  components: { LogoutIcon },
  computed: {
    masquerading() {
      return this.$store.state.users.masquerading;
    },
  },
  methods: {
    async stopMasquerading() {
      try {
        const data = await axios.post('/api/stop/masquerading');

        if (data.data.success) {
          this.$toasted.show('Stopping masquerading. Your page will refresh in 3 seconds.');

          setTimeout(() => {
            // noinspection JSValidateTypes
            window.location = '/events';
          }, 3000);
        }

      } catch(e) {
        // do something here if a failed stop-masquerading happens
        this.$toasted.error('Error: unable to stop masquerading at this time. Please refresh.');
      }
    }
  }
}
</script>

<style scoped>

</style>